import React from 'react'
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from 'mdbreact'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedinIn, faXing } from '@fortawesome/free-brands-svg-icons'

const today = new Date();

const Footer = () => {
  return (
    <MDBFooter className="ug-footer">
      <MDBContainer>
        <MDBRow className="pt-80 pb-5">
          <MDBCol lg="3" md="6" className="b-3 footer-col">
            <p className="footer-head">UNICOM Divisions</p>
            <p className="font-w-400 letter-spacing-1 text-gray-Dark text-small pb-3">
              <Link to="/unicom-global/divisions/" state={{btn: "Enterprise software"}}>Enterprise software</Link>
            </p>
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/unicom-global/divisions/" state={{btn: "IT infrastructure"}}>IT infrastructure</Link>
            </p>
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/unicom-global/divisions/" state={{btn: "Government tech"}}>Government technology</Link>            
            </p>
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/unicom-global/divisions/" state={{btn: "Real estate/finance"}}>Finance &amp; real estate</Link>            
            </p>
          </MDBCol>

          <hr className="clearfix w-100 d-md-none pb-3" />

          <MDBCol lg="3" md="6" className="b-3 footer-col">
            <p className="footer-head">Links</p>
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/ueber/">Über</Link>
            </p>       
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/karriere/">Karriere</Link>
            </p>                  
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/kontakt/">Kontakt</Link>
            </p>            
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/news/">Presse</Link>
            </p>
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/produkte/">Produkte</Link>
            </p>  
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/serviceangebot/">Serviceangebot</Link>
            </p>    
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/sitemap/">Seitenübersicht</Link>
            </p>
            
          </MDBCol>

          <hr className="clearfix w-100 d-lg-none pb-3" />

          <MDBCol lg="3" md="6" className="b-3 footer-col">
            <p className="footer-head">Privacy &amp; Legal</p>
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/cookie-policy/">Cookies</Link>
            </p>    
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/impressum/">Impressum</Link>
            </p>                
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/nutzungsbedingungen/">Nutzungsbedingungen</Link>
            </p>                
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/datenschutzerklaerung/">Datenschutzerklärung</Link>
            </p> 
            <p className="font-w-400 letter-spacing-1 text-gray-dark text-small pb-3">
              <Link to="/training-terms-and-conditions/">Allgemeine Geschäftsbedingungen für Schulungen</Link>
            </p>                       
          </MDBCol>

          <hr className="clearfix w-100 d-md-none pb-3" />

          <MDBCol lg="3" md="6" className="b-3 footer-col">
            <p className="footer-head">Social Media</p>
            <ul className="list-inline">
              <li>
                <a href="https://www.linkedin.com/company/detec-software-gmbh" target="_blank" aria-label="LinkedIn" rel="noopener">
                <FontAwesomeIcon icon={faLinkedinIn} className="fa-2x mx-2 mr-md-2"/>
                </a>
              </li>
              <li>
                <a href="https://www.xing.com/pages/detecsoftwaregmbh" target="_blank" aria-label="XING" rel="noopener">
                <FontAwesomeIcon icon={faXing} className="fa-2x mx-2 mr-md-2"/>
                </a>
              </li>
            </ul>
          </MDBCol>
        </MDBRow>

        <MDBRow className="align-items-center pb-60">
          <MDBCol className="text-left">
            <span className="font-w-700 letter-spacing-1 text-white text-extra-small text-uppercase">
              © {today.getFullYear()} DETEC Software GmbH &nbsp;&nbsp; | &nbsp;&nbsp; All rights reserved.
            </span>            
          </MDBCol>
        </MDBRow>
        
      </MDBContainer>
    </MDBFooter>
  )
}

export default Footer